module.exports = __webpack_public_path__ + "static/media/logo_kopsurat.bdbb92d5.png";